// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + ".chunk.js";
};